<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import SealNumberField from "@/views/trips/components/SealNumberField.vue";
import type { StopInfoSeal } from "@/types/trip";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    seals: StopInfoSeal[];
    travelOrderId: number;
    label?: string | null;
    errors?: Record<string, string | null>;
    disabled?: boolean;
  }>(),
  {
    label: null,
    errors: () => ({}),
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "add", travelOrderId: number): void;
  (e: "update", seal: StopInfoSeal): void;
  (e: "delete", seal: StopInfoSeal): void;
}>();
</script>

<template>
  <div class="mb-4">
    <div class="font-size-16 mb-4 text-grey-darken-2" data-qa="seals-section-label">
      {{ props.label }}
    </div>

    <seal-number-field
      v-for="seal in props.seals"
      :key="seal.tempId"
      :disabled="props.disabled"
      :error-message="props.errors[seal.tempId]"
      :model-value="seal"
      @delete="emit('delete', seal)"
      @update:model-value="emit('update', $event)"
    />

    <v-btn
      :disabled="props.disabled"
      class="font-size-12 font-weight-600 text-uppercase"
      color="primary"
      data-qa="add-seal-button"
      prepend-icon="mdi-plus"
      variant="text"
      @click="emit('add', props.travelOrderId)"
    >
      {{ t("trip.add-seal") }}
    </v-btn>
  </div>
</template>

<style lang="scss" scoped></style>
